import React, { useState, useEffect } from 'react';
import Tabs, { TabPane } from "rc-tabs";
import DashboardTab     from './DashboardTab';
import CompanyTab       from './CompanyTab';
import ContactDetailsTab from './ContactDetailsTab';
import NewsTab          from './NewsTab';
import EventsTab        from './EventsTab';
import ConnectionsTab   from './ConnectionsTab';
import StartupAgentsTab from './StartupAgentsTab';
import TeamTab          from './TeamTab';
import ProjectsTab      from './ProjectsTab';
import SupportTab       from './SupportTab';
import WhatsNewTab      from './WhatsNewTab';
import OrgOnboardingService from '../OrgOnboardingActions/OrgOnboardingService.js';
import { useCurrentUserHook } from "../../Authentication/useUserHook";

const MemberPortalListTable = (props) => {
  const { memberPortalIds = [], match:{params} } = props;

  const {currentUser} = useCurrentUserHook();

  const [activeTab, setActiveTab] = useState('dashboard');
  const [loading, setLoading] = useState(true);
  const [orgRegistration, setOrgRegistration] = useState({});

  useEffect(()=>{
    getOrgOnboarding();
  }, [currentUser?.current_organization_id])

  const onTabChange = (key) => {
    setActiveTab(key);
  }

  const getOrgOnboarding = async () =>{
    const {status, data} = await OrgOnboardingService.get(null, {'new_org_id': params.organization_id});
    if (status == 200) {
      setOrgRegistration(data);
      setLoading(false);
    }
  }

  const {data:regInfo={}} = orgRegistration;

  return (
    <div id="ct">
      <div className="app-content">
        <div className="app-header flex justspacebetween m-t-15">
          <div className="flex coldir">
            <div className="app-title">Member Portal</div>
            <div className="font-15 m-t-2">Welcome back, {regInfo.prim_contact}</div>
          </div>
        </div>

        <div className="app-content-section m-t-15">
          <Tabs moreIcon="+" activeKey={activeTab} onChange={onTabChange} className="bg-white">

            <TabPane tab={<span><i className="fas fa-th-large m-r-5"></i>Dashboard</span>} key="dashboard">
              <div className="p-15">
                <DashboardTab onNavigate={onTabChange} orgRegistration={orgRegistration} memberPortalIds={memberPortalIds} />
              </div>
            </TabPane>

            <TabPane tab={<span><i className="fas fa-building m-r-5"></i>Company</span>} key="company">
              <div className="p-15">
                <CompanyTab orgRegistration={orgRegistration}/>
              </div>
            </TabPane>

            <TabPane tab={<span><i className="fas fa-address-card m-r-5"></i>Contact Details</span>} key="contacts">
              <div className="p-15">
                <ContactDetailsTab orgRegistration={orgRegistration}/>
              </div>
            </TabPane>

            {/* <TabPane tab={<span><i className="fas fa-newspaper m-r-5"></i>News</span>} key="news">
              <div className="p-15">
                <NewsTab />
              </div>
            </TabPane> */}

            <TabPane tab={<span><i className="fas fa-calendar-alt m-r-5"></i>Events</span>} key="events">
              <div className="p-15">
                <EventsTab />
              </div>
            </TabPane>

            <TabPane tab={<span><i className="fas fa-users m-r-5"></i>Connections</span>} key="connections">
              <div className="p-15">
                <ConnectionsTab />
              </div>
            </TabPane>

            <TabPane tab={<span><i className="fas fa-chart-line m-r-5"></i>Startup Agents</span>} key="agents">
              <div className="p-15">
                <StartupAgentsTab />
              </div>
            </TabPane>

            <TabPane tab={<span><i className="fas fa-user-tie m-r-5"></i>Team</span>} key="team">
              <div className="p-15">
                <TeamTab />
              </div>
            </TabPane>

            <TabPane tab={<span><i className="fas fa-project-diagram m-r-5"></i>Projects</span>} key="projects">
              <div className="p-15">
                <ProjectsTab orgRegistration={orgRegistration}/>
              </div>
            </TabPane>

            <TabPane tab={<span><i className="fas fa-life-ring m-r-5"></i>Support</span>} key="support">
              <div className="p-15">
                <SupportTab />
              </div>
            </TabPane>

            <TabPane tab={<span><i className="fas fa-bell m-r-5"></i>What's New</span>} key="whats_new">
              <div className="p-15">
                <WhatsNewTab memberPortalIds={memberPortalIds} />
              </div>
            </TabPane>

          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default MemberPortalListTable;